"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var Button_1 = __importDefault(require("../../../Button"));
var DeckCategoryEditor_1 = __importDefault(require("../DeckCategoryEditor"));
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        root: {},
    });
});
var DeckCategoryEditorDialog = function (_a) {
    var deck = _a.deck, variant = _a.variant, onClose = _a.onClose, other = __rest(_a, ["deck", "variant", "onClose"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.Dialog, __assign({ maxWidth: "xs", fullWidth: true, className: classes.root }, other),
        react_1.default.createElement(core_1.DialogTitle, null,
            "Edit deck ",
            variant === 'category' ? 'categories' : 'subcategories'),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(DeckCategoryEditor_1.default, { deck: deck, variant: variant })),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(Button_1.default, { size: "large", color: "primary", variant: "text", onClick: onClose }, "Close"))));
};
exports.default = DeckCategoryEditorDialog;
//# sourceMappingURL=DeckCategoryEditorDialog.js.map